import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import CaretIcon from "sweet-web/components/icons/CaretIcon";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div<{ visible: boolean }>`
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  height: 60px;
  padding: 10px;
  z-index: 80;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  display: none;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.lightGray};
  @media screen and (max-width: 600px) {
    /* mobile styling */
    display: ${props => (props.visible ? "flex" : "none")};
  }
`;

const BackWrapper = styled(NavLink)`
  position: absolute;
  left: 0;
  height: 60;
  padding: 20px;
`;

const ChatTitle = styled.h1`
  font-size: 17px;
  font-weight: 600;
  color: ${colors.nearBlack};
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const ChatHeader: React.FC<Props> = props => {
  const { chatId } = props.match.params as { chatId: string };
  const {
    userType,
    chat,
    otherChatUserName,
    otherChatUserImage,
    otherChatUserInitials
  } = props;

  return (
    <Wrapper visible={Boolean(chatId)}>
      <BackWrapper to={"/c"}>
        <CaretIcon
          size={20}
          color={colors.gray}
          style={{ marginBottom: 7, transform: "rotate(180deg)" }}
        />
      </BackWrapper>
      <ChatTitle>{otherChatUserName}</ChatTitle>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { chatId } = ownProps.match.params as { chatId: string };

  return {
    userType: selectors.userType(state),
    chat: selectors.chat(chatId)(state),
    otherChatUserName: selectors.otherChatUserName(chatId)(state),
    otherChatUserImage: selectors.otherChatUserImage(chatId)(state),
    otherChatUserInitials: selectors.otherChatUserInitials(chatId)(state)
  };
};
const connector = connect(mapState);

export default withRouter(connector(ChatHeader));
